import React from 'react';
import { PlaidBankAccount } from '../../../Types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';

export default function BankAccounts({
  accounts,
  disabled,
  selectedAccountId,
  handleAccountSelect,
}: {
  accounts: Array<PlaidBankAccount>;
  disabled: boolean;
  selectedAccountId: string;
  handleAccountSelect: (event: React.ChangeEvent<HTMLInputElement>) => any;
}) {
  const accountsFiltered = accounts.filter(
    (account) =>
      account.subtype === 'checking' || account.subtype === 'savings',
  );

  return (
    <RadioGroup
      name="bank accounts"
      value={selectedAccountId}
      onChange={handleAccountSelect}
    >
      {accountsFiltered.map((account) => (
        <FormControlLabel
          key={account.id}
          value={account.id}
          control={<Radio color="primary" disabled={disabled} />}
          label={
            <Typography>
              {account.name} {account.mask && `(${account.mask})`}
            </Typography>
          }
        />
      ))}
    </RadioGroup>
  );
}
